import { ProposalCommandType } from 'graphql/generated'
import {
  getCommandDescription,
  IProposalCommandInputProps
} from './ProposalCommand.types'
import { useEffect } from 'react'

function ChangeGateDepositsCommand({
  onChange,
  onValidityChange,
  collective
}: IProposalCommandInputProps) {
  useEffect(() => {
    onChange({
      type: ProposalCommandType.CHANGE_GATE_DEPOSITS,
      gateDeposits: !collective.parameters.gateDeposits
    })
    // eslint-disable-next-line
  }, [collective.parameters.gateDeposits])

  const isValid = true
  useEffect(() => {
    onValidityChange(isValid)
    // eslint-disable-next-line
  }, [isValid])

  return (
    <div className="flex flex-col w-full">
      <div className="flex pt-4 justify-center items-center">
        <p className="text-gray-700 font-light text-sm">
          {getCommandDescription(
            ProposalCommandType.CHANGE_GATE_DEPOSITS,
            collective
          )}
        </p>
      </div>
    </div>
  )
}

export default ChangeGateDepositsCommand
